export const loginEnhancer = function (el) {
    el.querySelectorAll("input[type='radio']").forEach(function (input) {
        input.addEventListener("change", function (evt) {
            if (input.value == "yes") {
                document.querySelector(".login-section").style.display =
                    "block";
            } else {
                document.querySelector(".login-section").style.display =
                    "none";
            }
        });
    });
};
